import { hot } from 'react-hot-loader/root';
import React from 'react';
import SpyRolePage, { spyRolePagePropTypes } from './SpyRolePage';
import WhichSpyModule from '../components/WhichSpyModule';

const PublicSpyRolePage = ({ phrases, ...props }) => {
  const { roles, ...restOfPhrases } = phrases;
  return (
    <>
      <SpyRolePage
        showSpyRoleSubHeading={false}
        phrases={restOfPhrases}
        {...props}
      />
      <WhichSpyModule phrases={roles} />
    </>
  );
};

PublicSpyRolePage.propTypes = spyRolePagePropTypes;

export default hot(PublicSpyRolePage);
